module.exports = __webpack_public_path__ + "img/thumbnail_79344709_706380993222484_1609533732841062400_n_0.27b5788a.jpg";